import { PRIMARY_ORANGE } from '../../../constants/theme';

export const bloomsDefaults = {
  bloom_remember: 'Eu reconheço os conceitos básicos, mas não necessariamente entendo o que eles significam.',
  bloom_understand: 'Entendo o conteúdo de forma teórica e objetiva mas ainda não aplico.',
  bloom_apply: 'Aplico esse conhecimento em situações diversas, utilizando o que aprendi de forma prática.',
  bloom_analyse: 'Eu quebro as informações em partes menores para ver como elas se conectam. Investigo as razões, tiro conclusões e procuro evidências para apoiar minhas ideias.',
  bloom_evaluate: 'Eu combino partes isoladas dessa habilidade para formar um todo e crio conexões entre elas.',
  bloom_create: 'Eu apresento e defendo minhas opiniões e crio critérios de avaliação para medir a qualidade dessa habilidade.'
};

export const TAXONOMY_LEVELS = [
  { name: 'LEMBRO', range: '0-1', bloomKey: 'bloom_remember', color: '#dc2626' },
  { name: 'COMPREENDO', range: '1.5-3.5', bloomKey: 'bloom_understand', color: PRIMARY_ORANGE },
  { name: 'APLICO', range: '4-5.5', bloomKey: 'bloom_apply', color: '#eab308' },
  { name: 'ANALISO', range: '6-7.5', bloomKey: 'bloom_analyse', color: '#22c55e' },
  { name: 'AVALIO', range: '8-9.5', bloomKey: 'bloom_evaluate', color: '#16a34a' },
  { name: 'CRIO', range: '10', bloomKey: 'bloom_create', color: '#0d9488' },
];

export const colorMap = {
  LEMBRO: { barClass: 'competency-detail-legend-bar-red' },
  COMPREENDO: { barClass: 'competency-detail-legend-bar-orange' },
  APLICO: { barClass: 'competency-detail-legend-bar-yellow' },
  ANALISO: { barClass: 'competency-detail-legend-bar-purple' },
  AVALIO: { barClass: 'competency-detail-legend-bar-blue' },
  CRIO: { barClass: 'competency-detail-legend-bar-green' },
};

export const getTaxonomyLevel = (score) => {
  if (score <= 1) return 'LEMBRO';
  if (score <= 3.5) return 'COMPREENDO';
  if (score <= 5.5) return 'APLICO';
  if (score <= 7.5) return 'ANALISO';
  if (score <= 9.5) return 'AVALIO';
  return 'CRIO';
};

export const getTaxonomyLevels = (investment) => {
  const bloom = investment || {};
  return TAXONOMY_LEVELS.map((level) => ({
    name: level.name,
    range: level.range,
    color: level.color,
    borderColor: level.color,
    description: bloom[level.bloomKey]?.trim() || bloomsDefaults[level.bloomKey],
  }));
};
